<ng-container *transloco="let tOffline; read: 'shared.offline'">
  <div class="content">
    <span class="header">{{ tOffline("text") }}</span>
    <span>{{ tOffline("reconnecting") }}</span>
  </div>
</ng-container>
<app-spinner size="30px"></app-spinner>
